// extracted by mini-css-extract-plugin
module.exports = {"body":"i_Cf","video-container":"i_Cg","video":"i_Ch","informers":"i_Ci"};